import { render } from "./SidebarMenu3.vue?vue&type=template&id=24d1980c&scoped=true"
import script from "./SidebarMenu3.vue?vue&type=script&lang=js"
export * from "./SidebarMenu3.vue?vue&type=script&lang=js"

import "./SidebarMenu3.vue?vue&type=style&index=0&id=24d1980c&lang=scss&scoped=true"

import exportComponent from "../../../../../SINTEZ/OKCU/webadmin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24d1980c"]])

export default __exports__